import RectObject from "./RectObject";


class Platform extends RectObject{
    constructor() {
        super(...arguments);
        this.fillStyle = "#acd157"
    }
}

export default Platform